import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const PaidBlocks = ({ children }) => {

  const paymenetBlocks = useSelector(
        (state) => state?.paymentStripes?.getBlockByPlanId?.paymenet_blocks
      );

  if (!paymenetBlocks === 1) {
    return <Navigate to="/pricing" />;
  }
  return children;
};
